"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementService = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var field_join_1 = require("./field.join/field.join");
var field_join_ikecalc_wire_1 = require("./field.join/field.join.ikecalc.wire");
var field_join_poleforeman_powercircuit_1 = require("./field.join/field.join.poleforeman.powercircuit");
var field_join_poleforeman_wire_1 = require("./field.join/field.join.poleforeman.wire");
var MeasurementService = /** @class */ (function () {
    function MeasurementService() {
        this.__priority = 100;
    }
    MeasurementService.prototype.isFormSupported = function (form) {
        if (form == null) {
            return false;
        }
        if (form.metadata == null || form.metadata.import == null) {
            return false;
        }
        var type = form.metadata.import.type;
        return type === 'ikecalc' || type === 'spidacalc' || type === 'poleforeman';
    };
    MeasurementService.prototype.getFieldJoins = function (collection) {
        var fieldJoins = [];
        collection.forEachField(function (field) {
            if (!core_shared_1.CollectionModelFieldHeight.isHeightField(field)) {
                return;
            }
            if (field_join_ikecalc_wire_1.IkeCalcWireAttachmentHeightFieldJoin.accepts(field)) {
                var fieldJoin = new field_join_ikecalc_wire_1.IkeCalcWireAttachmentHeightFieldJoin(field);
                fieldJoins.push(fieldJoin);
            }
            else if (field_join_poleforeman_wire_1.PoleForemanWirePhaseHeightFieldJoin.accepts(field)) {
                var fieldJoin = new field_join_poleforeman_wire_1.PoleForemanWirePhaseHeightFieldJoin(field);
                fieldJoins.push(fieldJoin);
            }
            else if (field_join_poleforeman_powercircuit_1.PoleForemanPowerCircuitPhaseHeightFieldJoin.accepts(field)) {
                var fieldJoin = new field_join_poleforeman_powercircuit_1.PoleForemanPowerCircuitPhaseHeightFieldJoin(field);
                fieldJoins.push(fieldJoin);
            }
        });
        var matches = [];
        for (var i = 0; i < fieldJoins.length; i++) {
            var joiningField = fieldJoins[i];
            for (var j = i + 1; j < fieldJoins.length; j++) {
                var candidateJoiningField = fieldJoins[j];
                if (joiningField.type === candidateJoiningField.type && joiningField.field.schema.id === candidateJoiningField.field.schema.id && joiningField.joins(candidateJoiningField)) {
                    var match = new field_join_1.FieldJoinMatch(joiningField, candidateJoiningField);
                    matches.push(match);
                    break;
                }
            }
        }
        return matches;
    };
    return MeasurementService;
}());
exports.MeasurementService = MeasurementService;
//# sourceMappingURL=measurement.service.js.map